import type { Marketplace } from '@/types/marketplace';

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lookupMarketplaceName(code: string, marketplaces: Marketplace[]): string {
  return marketplaces.find((marketplace) => marketplace.code === code)?.name ?? capitalizeFirstLetter(code);
}

export function sprintf(format, ...args) {
  let i = 0;
  return format.replace(/%s/g, () => String(args[i++]));
}

export function formatStoresName(name: string, marketplaces: Marketplace[], addCountry = true): string {
  const parts = name.split('_');
  const country = parts.pop().toUpperCase();
  const topbarMarketplaces = lookupMarketplaceName(parts.join(' '), marketplaces);

  const marketplace = topbarMarketplaces !== parts.join(' ') ? topbarMarketplaces : parts.map(capitalizeFirstLetter).join(' ');
  const _marketplace = {
    Ebay: 'eBay',
  }[marketplace] ?? marketplace;

  return [_marketplace, addCountry ? ` (${country})` : undefined].filter(Boolean).join(' ');
}

export function pluralize(word: string, count: number): string {
  return count === 1 ? word : `${word}s`;
}

export function truncate(value: string, max: number, ellipsis = '...'): string {
  if (typeof value !== 'string') return '';
  if (max <= 0) return '';
  if (value.length <= max) return value;
  const cut = Math.max(0, max - ellipsis.length);
  return value.slice(0, cut) + ellipsis;
}
